<template>
    <el-form label-width="120px" v-loading="loading">
        <table class="w-full">
            <thead>
                <tr>
                    <td />
                    <td>Tracking #</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="shipment in form.shipments">
                    <td>
                        {{ shipment.size_type | capitalize }}
                    </td>
                    <td>
                        <el-input
                            v-if="
                                isApproved &&
                                can(Permissions.EDIT_ORDER_TRACKING)
                            "
                            v-model="shipment.tracking_number"
                        />
                        <span v-else>
                            <span v-if="shipment.tracking_number">{{
                                shipment.tracking_number
                            }}</span>
                            <span v-else>N/A</span>
                        </span>
                    </td>
                </tr>
                <tr v-if="isApproved && can(Permissions.EDIT_ORDER_TRACKING)">
                    <td />
                    <td>
                        <el-button
                            :loading="form.busy"
                            @click="submit()"
                            class="mt-10"
                            icon="mdi mdi-content-save"
                            type="primary"
                        >
                            Save Changes
                        </el-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </el-form>
</template>

<script>
import OrderUtils from "@/utils/order";
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            shipments: [],
            form: new Form({
                shipments: [],
            }),
            loading: false,
        };
    },
    created() {
        this.getShipments();
    },
    watch: {
        "order.id"() {
            this.getShipments();
        },
    },
    computed: {
        isApproved() {
            return OrderUtils.isApproved(this.order);
        },
    },
    methods: {
        getShipments() {
            this.loading = true;
            axios
                .get(`/web-api/order/${this.order.id}/shipment`)
                .then((response) => {
                    this.shipments = response.data.data;
                    this.initForm();
                })
                .finally(() => (this.loading = false));
        },
        initForm() {
            this.form.shipments = this.shipments.map((shipment) => ({
                ..._.pick(shipment, ["id", "tracking_number", "size_type"]),
            }));
        },
        submit() {
            App.put(`/web-api/order/${this.order.id}`, this.form).then(() => {
                this.$notify.success({
                    message: "Changes have been saved.",
                });
            });
        },
    },
};
</script>

<style scoped></style>
